const removeEmptyObjectProperties = (obj: any) => {
  const result: any = {};
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    if (typeof value === 'string' && !value) {
      return;
    }
    if (Array.isArray(value) && !value.length) {
      return;
    }
    result[key] = value;
  });
  return result;
};

export default removeEmptyObjectProperties;
